import { ValueDisplay } from '../../components/ValueDisplay'
import LineDisplay from './LineDisplay'
import { Input } from "baseui/input";
import { LabelMedium } from 'baseui/typography';
import { Block } from 'baseui/block';
import { IFG_SAUTER_HeatingSetpoint } from './types'

// api
import { useSetObjectValue } from '../../../hooks/useSetObjectValue';
import { FormattedMessage } from 'react-intl';



export const OperatorPanel = (props: IFG_SAUTER_HeatingSetpoint) => {

    const [reduceSetpoint, setReduceSetpoint, setReduceSetpointResult] = useSetObjectValue(props.id, props.resourceGroupId, "reduceSetpoint", props.reduceSetpoint);
    const onReduceSetpointChanged = (e: any) => setReduceSetpoint(parseFloat(e.target.value));

    const [maxOutTNormalMode, setMaxOutTNormalMode, setMaxOutTNormalModeResult] = useSetObjectValue(props.id, props.resourceGroupId, "maxOutTNormalMode", props.maxOutTNormalMode);
    const onMaxOutTNormalModeChanged = (e: any) => setMaxOutTNormalMode(parseFloat(e.target.value));

    const [maxOutTReducedMode, setMaxOutTReducedMode, setMaxOutTReducedModeResult] = useSetObjectValue(props.id, props.resourceGroupId, "maxOutTReducedMode", props.maxOutTReducedMode);
    const onMaxOutTReducedModeChanged = (e: any) => setMaxOutTReducedMode(parseFloat(e.target.value));

    const [maxReturnT, setMxReturnT, setMxReturnTResult] = useSetObjectValue(props.id, props.resourceGroupId, "maxReturnT", props.maxReturnT);
    const onMxReturnTChanged = (e: any) => setMxReturnT(parseFloat(e.target.value));

    const [delayTimeATLimit, setDelayTimeATLimit, setDelayTimeATLimitResult] = useSetObjectValue(props.id, props.resourceGroupId, "delayTimeATLimit", props.delayTimeATLimit);
    const onDelayTimeATLimitChanged = (e: any) => setDelayTimeATLimit(parseFloat(e.target.value));

    const [timeATAverage, setTimeATAverage, setTimeATAverageResult] = useSetObjectValue(props.id, props.resourceGroupId, "timeATAverage", props.timeATAverage);
    const onMxTimeATAverageChanged = (e: any) => setTimeATAverage(parseFloat(e.target.value));

    const [aTAverage, setATAverage, setATAverageResult] = useSetObjectValue(props.id, props.resourceGroupId, "aTAverage", props.aTAverage);
    const onATAverageChanged = (e: any) => setATAverage(parseFloat(e.target.value));
    return (

        <>
            <>
                <ValueDisplay value={props.actSetpoint} dimension={'°C'}></ValueDisplay>
            </>

            <LineDisplay {...props}> </LineDisplay>

            <Block gridRowGap='20px' display='flex'flexDirection='column' >
                <LabelMedium><FormattedMessage id="FG_SAUTER_HeatingSetpoint.reduceSetpoint" defaultMessage="Reduce Setpoint in ECO mode [K]" /></LabelMedium>
                <Input
                    value={reduceSetpoint}
                    onChange={onReduceSetpointChanged}
                    placeholder=""
                    disabled={setReduceSetpointResult.isLoading}
                    error={setReduceSetpointResult.isError}
                />
                <LabelMedium><FormattedMessage id="FG_SAUTER_HeatingSetpoint.maxOutTNormalMode" defaultMessage="Maximum outside temperature for NORMAL mode" /></LabelMedium>
                <Input
                    value={maxOutTNormalMode}
                    onChange={onMaxOutTNormalModeChanged}
                    placeholder=""
                    disabled={setMaxOutTNormalModeResult.isLoading}
                    error={setMaxOutTNormalModeResult.isError}
                />
                <LabelMedium><FormattedMessage id="FG_SAUTER_HeatingSetpoint.maxOutTReducedMode" defaultMessage="Maximum outside temperature for ECO mode" /></LabelMedium>
                <Input
                    value={maxOutTReducedMode}
                    onChange={onMaxOutTReducedModeChanged}
                    placeholder=""
                    disabled={setMaxOutTReducedModeResult.isLoading}
                    error={setMaxOutTReducedModeResult.isError}
                />
                <LabelMedium><FormattedMessage id="FG_SAUTER_HeatingSetpoint.maxReturnT" defaultMessage="Maximum returntemperature" /></LabelMedium>
                <Input
                    value={maxReturnT}
                    onChange={onMxReturnTChanged}
                    placeholder=""
                    disabled={setMxReturnTResult.isLoading}
                    error={setMxReturnTResult.isError}
                />
                <LabelMedium><FormattedMessage id="FG_SAUTER_HeatingSetpoint.delayTimeATLimit" defaultMessage="Delaytime outtemperatur limit" /></LabelMedium>
                <Input
                    value={delayTimeATLimit}
                    onChange={onDelayTimeATLimitChanged}
                    placeholder=""
                    disabled={setDelayTimeATLimitResult.isLoading}
                    error={setDelayTimeATLimitResult.isError}
                />
                <LabelMedium><FormattedMessage id="FG_SAUTER_HeatingSetpoint.timeATAverage" defaultMessage="Time outtemperatur average" /></LabelMedium>
                <Input
                    value={timeATAverage}
                    onChange={onMxTimeATAverageChanged}
                    placeholder=""
                    disabled={setTimeATAverageResult.isLoading}
                    error={setTimeATAverageResult.isError}
                />
                <LabelMedium><FormattedMessage id="FG_SAUTER_HeatingSetpoint.aTAverage" defaultMessage="Outtemperatur average" /></LabelMedium>
                <Input
                    value={aTAverage}
                    onChange={onATAverageChanged}
                    placeholder=""
                    disabled={setATAverageResult.isLoading}
                    error={setATAverageResult.isError}
                />
            </Block>
        </>
    )
}

